import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCustomerMonthlyPlans from './ReportCustomerMonthlyPlans'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCustomerMonthlyPlans} />
    </Switch>
)

export default Components
